module.exports = __webpack_public_path__ + "img/app-go.e85c8f79.png";